import React from 'react'



export const routes = {
    auth: '/logIn',
    app: 'app',
    dashboard: '/dashboard',
    forgot: '/auth/forgot',
    signup: 'signup',
    forget: 'forget',
    createPassword: 'createPassword',
    changePassword: 'changePassword',
    myVault: 'My Vault',
    generateMemory: 'Generate a Memory',
    myProfile: 'My Account',
    bottomTab: 'bottomTab',
    memoryDetail: 'memoryDetail',
    myMemory: 'myMemory',
    createPin: 'createPin',
    enterPin: 'enterPin',
    selectMemories: 'selectMemories',
    createMemory: 'createMemory',
    editMemory: 'editMemory',
    myFriends: 'myFriends',
    addFriend: 'addFriend',
    editProfile: 'editProfile',
    notification: '/notification',
    setting: 'settings',
    drawerTab: 'drawerTab',
    policy: 'polices',
    terms: 'Terms',
    tagFriend: 'selectFriends',
    feedback: 'feedback',
    home: "/home",
}

